import { render, staticRenderFns } from "./SearchResultCommunityItem.vue?vue&type=template&id=05a32694&scoped=true"
import script from "./SearchResultCommunityItem.vue?vue&type=script&lang=js"
export * from "./SearchResultCommunityItem.vue?vue&type=script&lang=js"
import style0 from "./SearchResultCommunityItem.vue?vue&type=style&index=0&id=05a32694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a32694",
  null
  
)

export default component.exports